import React, { useState } from 'react';
import { Container } from '../Container';
import { Source } from '../../common/constants';
import { PageType } from '../../common/types';

export interface ModalContainerProps {
    initialEmail?: string;
    initialPage?: PageType;
    showRecaptcha: boolean;
    source: Source;
    variant?: 'client' | 'designer' | 'invite';
    onAuthSuccess: () => void;
    target?: string;
}

export function ModalContainer({
    initialEmail,
    initialPage = 'signup',
    showRecaptcha,
    source,
    variant,
    onAuthSuccess,
    target,
}: ModalContainerProps) {
    const [page, setPage] = useState<PageType>(initialPage);

    function handleSetPage(newPage: PageType) {
        setPage(newPage);
    }

    return (
        <Container
            email={initialEmail}
            page={page}
            setPage={handleSetPage}
            source={source}
            showRecaptcha={showRecaptcha}
            variant={variant}
            onAuthSuccess={onAuthSuccess}
            target={target}
        />
    );
}
